'use client';
import { useTranslation } from 'react-i18next';

import Accept from '@icons/Accept.svg';
import Class from '@icons/Class.svg';
import Date from '@icons/Date.svg';
import Info from '@icons/Info.svg';
import Time from '@icons/Time.svg';

import { InfoContainer } from '@components/Common';
import { ShiftInfoCardBaseProps } from '@components/ShiftInfoCards/interfaces';
import { InfoItem, ShiftInfoContainer, TimeInfoItem } from '@components/ShiftInfoCards/styles';
import { Text } from '@components/TermsCheckbox';

import { formatDisplayDate, formatDisplayTime } from '@utils/helpers';
import { getTeacherDisplayTranslationKey } from '@utils/shiftFilters';

/**
 * Shift info card used on School Shifts page with teacher information and reactions
 */
export const SchoolShiftInfoCard = ({
  shiftId,
  group,
  date,
  timeFrom,
  timeUntil,
  teacherName,
  teacherContext,
  numberOfReactions,
  onClick,
}: ShiftInfoCardBaseProps) => {
  const { t } = useTranslation('common');

  return (
    <ShiftInfoContainer
      key={shiftId}
      onClick={onClick}
      type="button"
      aria-label={'shift info card'}>
      <InfoContainer>
        <InfoItem>
          <Class />
          <Text>{`Groep ${group}`}</Text>
        </InfoItem>
        <TimeInfoItem>
          <InfoItem>
            <Date />
            <Text>{formatDisplayDate(date)}</Text>
          </InfoItem>
          <InfoItem>
            <Time />
            <Text>{`${formatDisplayTime(timeFrom)} - ${formatDisplayTime(timeUntil)}`}</Text>
          </InfoItem>
        </TimeInfoItem>
        {teacherName && (
          <InfoItem>
            <Accept />
            <Text>
              {t(getTeacherDisplayTranslationKey(teacherContext, date, timeFrom, timeUntil), {
                substituteName: teacherName,
              })}
            </Text>
          </InfoItem>
        )}
        {!teacherName && (
          <InfoItem>
            <Info />
            <Text>
              {numberOfReactions && numberOfReactions > 0
                ? t('schoolShifts.numberReacted', { number: numberOfReactions })
                : t('teacherShifts.notReacted')}
            </Text>
          </InfoItem>
        )}
      </InfoContainer>
    </ShiftInfoContainer>
  );
};
